export const products = [
  {
    id: 1,
    link: 'https://github.com/sourabhpatole',
    name: 'DevTinder – Developer Networking Platform',
    desc: 'A matching and networking application for software developers. Features real-time matching, profile discovery, and secure messaging. Hosted on AWS using Nginx as a reverse proxy for optimized routing and scalability.',
    tags: ['React.js', 'Node.js', 'MongoDB', 'AWS', 'Nginx'],
  },
  {
    id: 2,
    link: 'https://github.com/sourabhpatole',
    name: 'AI-Powered Talent Acquisition Platform',
    desc: 'A multi-tenant SaaS platform featuring automated interview management, AI-driven candidate evaluation, and dynamic question generation integrated with Gemini AI.    Hosted with enterprise workflows in mind.',
    tags: ['React.js', 'Node.js', 'MongoDB', 'Gemini AI'],
  },
  {
    id: 3,
    link: 'https://github.com/sourabhpatole',
    name: 'WhatsApp Messaging SaaS Application',
    desc: 'A workflow automation SaaS platform integrating the WhatsApp Cloud API and webhooks with JWT authentication and role-based access control (RBAC).   ',
    tags: ['React.js', 'Node.js', 'Express.js', 'WhatsApp API'],
  },
  {
    id: 4,
    link: 'https://github.com/sourabhpatole',
    name: 'Web Accessibility Enhancement Project',
    desc: 'An optimization initiative implementing ARIA roles, semantic HTML, and keyboard navigation to achieve WCAG 2.1 AA compliance and boost screen reader scores by 40%.   ',
    tags: ['React.js', 'WCAG 2.1', 'ARIA', 'Semantic HTML'],
  },
  {
    id: 5,
    link: 'https://github.com/sourabhpatole',
    name: 'Crypto Tracker & Analytics Dashboard',
    desc: 'A lightweight financial tracking utility that consumes public REST APIs to stream live token metrics, visualize historical candlestick trends, and calculate wallet balances.',
    tags: ['React.js', 'Chart.js', 'REST API', 'Tailwind CSS'],
  },
  {
    id: 6,
    link: 'https://github.com/sourabhpatole',
    name: 'Job Hunter n8n AI Automation Agent',
    desc: 'An autonomous workflow agent that scrapes job tracking boards, processes listings using AI nodes, and sends automated application alerts. Orchestrated locally and deployed inside a isolated Docker container infrastructure.',
    tags: ['n8n', 'Docker', 'Automation', 'AI Agents', 'REST API'],
  },
];
